export const FETCH_ADVFILTER_REQUEST = "FETCH_ADVFILTER_REQUEST";
export const FETCH_ADVFILTER_SUCCESS = "FETCH_ADVFILTER_SUCCESS";
export const FETCH_ADVFILTER_FAILURE = "FETCH_ADVFILTER_FAILURE";
